
const InvoiceRoutes = [
    {
        path: '',
        name: 'invoice-index',
        component: () => import("@/views/overview.vue")
    },
    {
        path: 'form',
        name: 'form-invoice',
        component: () => import("@/components/invoice/upload.vue")
    },
    {
        path: 'upload',
        name: 'invoice-upload',
        component: () => import("@/components/invoice/upload.vue")
    },
    {
        path: 'outgoing-upload',
        name: 'outgoing-invoice-upload',
        component: () => import("@/components/invoice/upload.vue")
    },
    {
        path: 'statements/upload',
        name: 'bank-statement-upload',
        component: () => import("@/components/bank-statement/upload.vue")
    },
    {
        path: 'statements/form',
        name: 'bank-statement-form',
        component: () => import("@/components/bank-statement/form.vue")
    },
    {
        path: 'statements/transactions',
        name: 'bank-statement-transactions',
        component: () => import("@/components/bank-statement/transactions.vue")
    }
];
export default InvoiceRoutes
